import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { Department } from '../../department/department.model';
import { EnvironmentLoaderService } from '../../../shared/services/environment-loader.service';
import { AppState } from 'src/app/app.state';
import { Organization } from '../../organization/organization-models';
import { PricePolicy } from '../../prices/price-policies/interfaces/price-policy';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AccessGroup } from '../../access-groups/access-group.model';
import { RequiresFeatureRoleDirective } from '../../../shared/directives/requires-feature-role.directive';
import { ChargingStationLocationListComponent } from '../charging-station-location-list/charging-station-location-list.component';
import { ChargingStationLocationsStateService } from './charging-station-locations.state.service';
import { Permission } from 'src/app/shared/enums/permission.enum';
import { ChargingStationLocationCreateEditModalComponent } from '../charging-station-location-create-modal/charging-station-location-create-edit-modal';
import { MatButton } from '@angular/material/button';
import { ChargingStationLocationFiltersComponent } from 'src/app/shared/components/charging-station-location-filters/charging-station-location-filters.component';

@Component({
  selector: 'adm-charging-station-location-overview',
  templateUrl: './charging-station-location-overview.component.html',
  styleUrls: ['./charging-station-location-overview.component.scss'],
  imports: [RequiresFeatureRoleDirective, ChargingStationLocationListComponent, ChargingStationLocationFiltersComponent, MatButton],
  providers: [ChargingStationLocationsStateService],
  encapsulation: ViewEncapsulation.None,
})
export class ChargingStationLocationOverviewComponent {
  private dialog = inject(MatDialog);
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private authService = inject(AuthService);
  public state = inject(ChargingStationLocationsStateService);
  public appState = inject(AppState);
  public roles = this.environmentLoaderService.virtualRoles;
  public isPricePolicyViewer = this.authService.hasRole(this.roles[Permission.PricePolicyRead]);

  async openCreateLocationDialog() {
    const dialogRef = this.dialog.open(ChargingStationLocationCreateEditModalComponent, {
      width: '650px',
    });

    dialogRef.afterClosed().subscribe(chargingStationLocationIdentifier => {
      if (chargingStationLocationIdentifier) {
        this.state.ToFirstPage({
          chargingStationLocationIdentifier: chargingStationLocationIdentifier,
        });
      }
    });
  }

  public searchInput(source: Observable<string>) {
    source.subscribe(searchTerm => {
      this.state.ToFirstPage({
        query: searchTerm,
      });
    });
  }

  public onAccessGroupSelected(accessGroup: AccessGroup | null): void {
    this.state.ToFirstPage({
      accessGroupIdentifier: accessGroup?.identifier,
    });
  }

  public onOrganizationSelected(organization: Organization | null): void {
    this.state.ToFirstPage({
      organizationId: organization?.id,
    });
  }

  public onDepartmentSelected(department: Department | null): void {
    this.state.ToFirstPage({
      departmentId: department?.id,
    });
  }

  public onPricePolicySelected(pricePolicy: PricePolicy | null): void {
    this.state.ToFirstPage({
      pricePolicyId: pricePolicy?.id,
    });
  }
  updateLocationWithErrorFilter(checked: boolean) {
    this.state.ToFirstPage({
      locationsWithErrorsInSetup: checked,
    });
  }
}
